import { getListViewStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Determines if we need to allot space for the campaign or not
 */
export const setCanAllotSpaceForFocusedOtherCampaign = mutatorAction(
    'setCanAllotSpaceForFocusedOtherCampaign',
    (canAllot: boolean) => {
        getListViewStore().canAllotSpaceForFocusedOtherCampaign = !!canAllot;
    }
);
